import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { HelixLoader } from "@/components/ui/helix-loader";
import { useAuth } from "@/contexts/AuthContext";

type Props = {
  children: ReactNode;
};

export default function PublicOnlyRoute({ children }: Props) {
  const { session, loading, hasUsername } = useAuth();

  if (loading) {
    return (
      <div style={{ background: '#0F172A', 
                    width: '100vw', 
                    height: '100vh' }} />
    );
  }

  if (session && hasUsername) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
}
